module.exports = __webpack_public_path__ + "img/lanscape-1.c70da609.jpg";